import { ABaseModel } from '../abstracts/ABaseModel.js';
import { IListInfo, IListResult, IPaginationInfo, IPaginationResult } from '../interfaces/List.js';

/**
 * ListInfo
 */
class ListInfo extends ABaseModel implements IListInfo {
  items: number;
  type: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * ListResult
 */
class ListResult extends ABaseModel implements IListResult {
  items: Array<any>;
  collection: ListInfo;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PaginationInfo
 */
class PaginationInfo extends ListInfo implements IPaginationInfo {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  totalPages: number;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * PaginationResult
 */
class PaginationResult extends ABaseModel implements IPaginationResult {
  items: Array<any>;
  pagination: PaginationInfo;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { ListInfo, ListResult, PaginationInfo, PaginationResult };
